import { isAxiosError } from 'axios';

import { getApiV1UsersUserIdCustomerSubPlansCurrent } from '@/open-api/users/users';

import type { SubscriptionStatusCode } from '@/components/Modals/CreateAccount/checkout/status-codes';

const HTTP_NOT_FOUND = 404;

export const checkSubscriptionStatus = async (
  userId: number | undefined
): Promise<{
  code: SubscriptionStatusCode | null;
  error: string | null;
}> => {
  if (!userId) {
    return {
      code: null,
      error: 'Sorry, something went wrong',
    };
  }

  try {
    const plan = await getApiV1UsersUserIdCustomerSubPlansCurrent(userId);

    const code = plan?.subscriptionStatusId ?? null;

    return {
      code,
      error: code ? null : 'Plan Not Found.',
    };
  } catch (error) {
    if (isAxiosError(error) && error.response?.status === HTTP_NOT_FOUND) {
      return {
        code: null,
        error: 'Plan Not Found.',
      };
    }

    return {
      code: null,
      error: 'Sorry, something went wrong',
    };
  }
};
